module.exports = __webpack_public_path__ + "static/media/nugget-icon-white.ca70e6c8.svg";